"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addObjectKeys = addObjectKeys;
exports.deepClone = deepClone;
exports["default"] = void 0;
exports.getObjectKeyName = getObjectKeyName;
exports.getValueAtKeypath = getValueAtKeypath;
exports.isObject = isObject;
exports.setValueAtKeypath = setValueAtKeypath;
exports.tryParseObject = tryParseObject;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
/**
 * Deep Clone
 *
 * @param {object} object - an object to clone
 * @returns {object} - a new instance of the provided object with identical properties
 */
function deepClone(object) {
  return JSON.parse(JSON.stringify(object));
}

/**
 * Is Object
 *
 * @param {object} object - an object to test
 * @returns {bool} - bool indicating if the provided object is an object
 */
function isObject(object) {
  return object !== null && _typeof(object) === 'object' && !Array.isArray(object);
}

/**
 * Try Parse Object
 *
 * @param {string} value - a string which may represent a JSON object
 * @returns {object} - an object if the input string was a JSON object, else the raw input value
 */
function tryParseObject(value) {
  try {
    return JSON.parse(value);
  } catch (ex) {
    return value;
  }
}

/**
 * Get Object Key Name
 *
 * @param {object} object - an object read the first key name from
 * @returns {string} - the name the object key
 */
function getObjectKeyName(object) {
  if (isObject(object)) {
    return Object.keys(object)[0] || null;
  }
  return null;
}

/**
 * Get Value at Keypath
 *
 * @param {object} object - object to access property from
 * @param {string} keypath - keypath to the property to be accessed
 * @returns {object} - value of the property at the supplied keypath
 */
function getValueAtKeypath(object, keypath) {
  // eslint-disable-line complexity
  if (!isObject(object)) {
    return null;
  }
  var parts = keypath.split('.');
  var firstPart = parts[0];
  var remainingParts = parts.slice(1);
  if (remainingParts.length === 0) {
    if (typeof object[firstPart] === 'undefined') {
      return null;
    }
    return object[firstPart];
  }
  var nextObject = object[firstPart];
  var nextKeypath = remainingParts.join('.');
  return getValueAtKeypath(nextObject, nextKeypath);
}

/**
 * Set Value at Keypath
 *
 * @param {object} object - object to set property in
 * @param {string} keypath - keypath to the property to be set
 * @param {object} value - value to set in the provided object
 * @param {bool} castToOriginalType - default to false - when set a check will be made for
 * an existing value at the provided keypath, if found the new value will be cast to the type
 * of the existing value
 * @returns {object} - new object with the property set
 */
function setValueAtKeypath(object, keypath, value) {
  var castToOriginalType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var objectCopy = deepClone(object);

  /* eslint-disable no-param-reassign, complexity */
  function setValueForKey(node, currentPath) {
    var parts = currentPath.split('.');
    var firstPart = parts[0];
    if (parts.length === 1) {
      if (castToOriginalType && node[firstPart] !== undefined) {
        var originalTypeConstructor = node[firstPart].constructor;
        node[firstPart] = originalTypeConstructor(value);
      } else {
        node[firstPart] = value;
      }
    } else {
      if (_typeof(node[firstPart]) !== 'object') {
        node[firstPart] = {};
      }
      var remainingParts = parts.slice(1);
      var nextKeypath = remainingParts.join('.');
      setValueForKey(node[firstPart], nextKeypath);
    }
  }
  /* eslint-enable no-param-reassign, complexity */

  setValueForKey(objectCopy, keypath);
  return objectCopy;
}

/**
 * Add Object Keys
 * Sets or updates an array of key/value items in the provided object
 *
 * @param {object} object - Object to set values in
 * @param {array} keyValueArray - an array of key/value items
 * @returns {object} - Clone of provided object updated with values from keyValueArray
 */
// eslint-disable-next-line complexity
function addObjectKeys(object, keyValueArray) {
  if (!keyValueArray || keyValueArray.length === 0) {
    return object;
  }
  var firstKeyValueItem = keyValueArray[0];
  var keyName = getObjectKeyName(firstKeyValueItem);
  var keyValue = Object.keys(firstKeyValueItem).map(function (k) {
    return firstKeyValueItem[k];
  })[0];
  var existingValue = getValueAtKeypath(object, keyName);
  var existingValueIsBasicType = existingValue && !isObject(existingValue) && !Array.isArray(existingValue);
  var updatedObject = setValueAtKeypath(object, keyName, keyValue, existingValueIsBasicType);
  var remainingItems = keyValueArray.slice(1);
  return addObjectKeys(updatedObject, remainingItems);
}
var _default = exports["default"] = {
  deepClone: deepClone,
  getObjectKeyName: getObjectKeyName,
  getValueAtKeypath: getValueAtKeypath,
  setValueAtKeypath: setValueAtKeypath,
  addObjectKeys: addObjectKeys
};